import { gql } from '@apollo/client';

export const QGlobalDataQuery = gql`
  query QGlobalDataQuery {
    getJobs {
      ok
      error
      data {
        label
        value
        caisse
      }
    }
    getProfessionalSituations {
      ok
      error
      data {
        label
        value
      }
    }
    getSocioProfessionalCategories {
      ok
      error
      data {
        label
        value
      }
    }
    getActivities {
      ok
      error
      data {
        label
        value
      }
    }
    getProject {
    ok
    error
    data
    }
    getRegimeObligatoire {
      ok
      error
      data {
        regimes {
          label
          value
        }
        regimeCodes {
          regime
          label
          value
        }
        caisseCodes {
          regimeCode
          label
          value
        }
      }
    }
    getInsurances {
      ok
      error
      data {
        value
        label
      }
    }
    getPhoneIndicatives {
      ok
      error
      data {
        value
        label
        subLabel
      }
    }
    getAnalyticsInformation {
      ok
      error
      data {
        projectNumber
        signatureType
        selectedFormulas
        monthlyPrices
        yearlyPrices
      }
    }

    getActiveUserInformation {
      ok
      error
      data {
        roles
        status
      }
    }
    getUsersInformation {
      ok
      error
      data {
        roles
        userId
        isActive
      }
    }
    getInsurances {
      ok
      error
      data {
        value
        label
      }
    }
    getFamilySituations {
      ok
      error
      data {
        value
        label
      }
    }
    getOrganismCodes {
      ok
      error
      data {
        regimCode
        caseNumbers
      }
    }
    getProductCode {
      productCode
    }
    getViewMode {
      ok
      error
      viewMode
    }
    getQAToolsEnabled {
      enabled
    }
  }
`;
